import Kr from './src/kr/kr';

import SelectColor from './src/modules/SelectColor';
import GaEventPush from './src/modules/GaEventPush';

import './src/components/LayoutGallery';
import './src/components/NavTo';


import './src/components/Slider';
import './src/components/FakeSelects';
//import './src/components/VideoAutoplay';
import './src/components/PresentationMainpage';
// import './src/components/ReplaceImageSrc';
import './src/components/PresentationMainpage';
import './src/components/SliderOpinions';
import './src/components/SubpageSwiper';
import './src/components/OpenControllsMenu';
import './src/components/SwipeUp';
import './src/components/HomepageFilm';
import './src/components/SubpageReplaceImageSrc';
import './src/components/CategorySubmenu';
import './src/components/CustomSelects';
import './src/components/GetUploadedFilename';
import './src/components/ToggleReviewFormVisibility';
import './src/components/HandleFormReviewSubimt';
import './src/components/HeaderHamburgerOpen';
import './src/components/AppendNavbarLinks';
import './src/components/ResponsiveNavbarSubmenu';
import './src/components/CategorySlider';
import './src/components/FireplacesSlider';
import './src/components/HeaderFixedOnScroll';
import './src/components/CategoryMenuScroll';
import './src/components/Tabs';
import './src/components/Newsletter';
import './src/components/OpenDetails';

import './src/components/Product/FullVideoProduct';
import './src/components/Product/VariantsFilter';
import './src/components/Product/AddToCart';
import './src/components/Product/BuyModal';

import './src/components/Cart/CartQuantity';
import './src/components/Cart/WooTabs';
import './src/components/Cart/WooCountry';

import './src/components/Contact/OfficerMap';
import './src/components/Contact/BranchMap';
import './src/components/Architects/SearchInput';

const app = new Kr.App;
app.use('select-color', SelectColor);
app.use('ga-event-push', GaEventPush);
app.run();
